import appFileDownload from "../../views/appFileDownload.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("file-download", {
    url: "file-download/:token/*resource",
    parent: "app",
    views: {
      view: {
        template: appFileDownload,
      },
    },
    reloadOnSearch: false,
    data: { title: "FileDownload" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/fileDownload/fileDownload.urls.js